import script from "./SwitchAtom.vue?vue&type=script&setup=true&lang=ts"
export * from "./SwitchAtom.vue?vue&type=script&setup=true&lang=ts"

import "./SwitchAtom.vue?vue&type=style&index=0&id=5b852d96&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5b852d96"]])

export default __exports__